import React from 'react';
import styles from './GridLoadingIndicator.module.css';

/**
 * Loading indicator specifically designed for the character/scenario grid
 * Maintains the grid's dimensions while showing a loading animation
 */
const GridLoadingIndicator: React.FC = () => {
  // Create placeholder items to maintain grid layout (5 per row for desktop)
  const placeholders = Array(10).fill(null);
  
  return (
    <div className={styles.gridLoadingContainer}>
      {placeholders.map((_, index) => (
        <div key={index} className={styles.placeholderItem}>
          <div className={styles.placeholderImage}></div>
          <div className={styles.placeholderContent}>
            <div className={styles.placeholderTitle}></div>
            <div className={styles.placeholderText}></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GridLoadingIndicator; 